import {
	ActionIcon,
	Box,
	Flex,
	Image,
	Tooltip,
} from '@mantine/core';
import classes from './ProfilePictureUpload.module.css';

import AvatarImage from '@assets/images/eskimo.png';
import { Button, Text } from '@components/v2/ui';
import { FileButton } from '@mantine/core';
import useStore from '@store/index';
import {
	IconSend2,
	IconTrash,
	IconUserCircle,
} from '@tabler/icons-react';
import { truncate } from 'lodash';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const ProfilePictureUpload = (props: {
	onUpload: (formData: FormData | null) => void;
	src?: string;
}) => {
	const { t } = useTranslation();
	const [file, setFile] = useState<File | null>(null);
	const [preview, setPreview] = useState<string | null>(
		null
	);
	const resetRef = useRef<() => void>(null);
	const { getUser } = useStore();
	const user = getUser();

	const handleFileChange = (
		selectedFile: File | null
	) => {
		setFile(selectedFile);
		const formData = new FormData();
		formData.append('route', 'users');
		formData.append('document', user?.id || '');
		if (selectedFile)
			formData.append('file', selectedFile);

		if (selectedFile) {
			const objectUrl = URL.createObjectURL(selectedFile);
			setPreview(objectUrl);
		} else {
			setPreview(null);
		}

		props.onUpload(formData);
	};

	const handleDelete = () => {
		setFile(null);
		setPreview(null);
		resetRef.current?.();
		props.onUpload(null);
	};

	useEffect(() => {
		if (props.src) {
			setPreview(props.src);
		}
	}, [props.src]);

	return (
		<Box className={classes.rowPicture}>
			<Box className={classes.previewPicture}>
				{preview ? (
					<Image
						src={preview}
						className={classes.avatar}
						fallbackSrc={AvatarImage}
					/>
				) : (
					<IconUserCircle
						color="var(--mantine-color-igluPrimary-9)"
						stroke={1.5}
						size={80}
					/>
				)}
				<Flex
					direction="column"
					align="flex-start"
					justify="center"
				>
					<Tooltip
						label={file?.name}
						disabled={
							!!(
								file &&
								file.name &&
								file?.name?.length <= 30
							) || !file
						}
					>
						<Box>
							<Text variant="subtitle1" c={'#1D3965'}>
								{file && file.name
									? truncate(file.name, {
											length: 30,
										})
									: t('global.profilePicture')}
							</Text>
						</Box>
					</Tooltip>
					<Text variant="body2" c={'#727272'}>
						{t('global.infoUploadPicture')}
					</Text>
				</Flex>
			</Box>
			<Box className={classes.actionsPicture}>
				<FileButton
					resetRef={resetRef}
					onChange={handleFileChange}
					accept="image/png,image/jpeg"
				>
					{(props) => (
						<Button
							size="xs"
							variant="primary"
							leftSection={
								<IconSend2
									style={{
										width: '24px',
										height: '24px',
									}}
									stroke={1.5}
									color="#D2E0F4"
								/>
							}
							{...props}
						>
							{t('global.uploadNewPicture')}
						</Button>
					)}
				</FileButton>

				<ActionIcon
					radius={'25px'}
					variant="outline"
					color="#ADD2EA"
					h={'48px'}
					w={'48px'}
					onClick={handleDelete}
				>
					<IconTrash
						style={{ width: '24px', height: '24px' }}
						stroke={1.5}
						color="#727272"
					/>
				</ActionIcon>
			</Box>
		</Box>
	);
};
